__turbopack_context__.v({
  "components": "main-module-scss-module__ofRKla__components",
  "container": "main-module-scss-module__ofRKla__container",
  "landingPage": "main-module-scss-module__ofRKla__landingPage",
  "leftNavigation": "main-module-scss-module__ofRKla__leftNavigation",
  "link": "main-module-scss-module__ofRKla__link",
  "main": "main-module-scss-module__ofRKla__main",
  "navBar": "main-module-scss-module__ofRKla__navBar",
  "search": "main-module-scss-module__ofRKla__search",
  "section": "main-module-scss-module__ofRKla__section",
  "title": "main-module-scss-module__ofRKla__title",
});
